// import { createContext, useContext, useEffect, useState } from "react";

// // Create context
// const AuthContext = createContext();

// // Export useAuth hook
// export const useAuth = () => useContext(AuthContext);

// // Provider
// export const AuthProvider = ({ children }) => {
//   const [token, setToken] = useState(localStorage.getItem("authToken"));

//   const login = (newToken) => {
//     localStorage.setItem("authToken", newToken);
//     setToken(newToken);
//   };

//   const logout = () => {
//     localStorage.removeItem("authToken");
//     setToken(null);
//   };

//   useEffect(() => {
//     const savedToken = localStorage.getItem("authToken");
//     if (savedToken) {
//       setToken(savedToken);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ token, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// src/components/context/AuthContext.jsx
// import { createContext, useContext, useEffect, useState } from "react";

// const AuthContext = createContext();

// export const useAuth = () => useContext(AuthContext);

// export const AuthProvider = ({ children }) => {
//   const [token, setToken] = useState(localStorage.getItem("authToken"));
//   const [userName, setUserName] = useState(
//     localStorage.getItem("authUserName")
//   );

//   const login = (newToken, name, id) => {
//     // console.log("newToken, name", name, id);
//     // debugger;
//     localStorage.setItem("authToken", newToken);
//     localStorage.setItem("authUserName", name);
//     localStorage.setItem("authUserId", id);
//     // localStorage.setItem("authUserId", slug);
//     console.log("newToken, name", name, id);
//     debugger;
//     setToken(newToken);
//     setUserName(name);
//   };

//   const logout = () => {
//     localStorage.removeItem("authToken");
//     localStorage.removeItem("authUserName");
//     localStorage.removeItem("authUserId");
//     setToken(null);
//     setUserName(null);
//   };

//   useEffect(() => {
//     const savedToken = localStorage.getItem("authToken");
//     const savedName = localStorage.getItem("authUserName");
//     if (savedToken) {
//       setToken(savedToken);
//       setUserName(savedName);
//     }
//   }, []);

//   return (
//     <AuthContext.Provider value={{ token, userName, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

import { createContext, useContext, useEffect, useState } from "react";
// import { ensureGuestToken } from "../../utils/guestHelper";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [userName, setUserName] = useState(
    localStorage.getItem("authUserName")
  );

  const login = (newToken, name, id) => {
    localStorage.setItem("authToken", newToken);
    localStorage.setItem("authUserName", name);
    localStorage.setItem("authUserId", id);
    localStorage.removeItem("guest_token");
    setToken(newToken);
    setUserName(name);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUserName");
    localStorage.removeItem("authUserId");
    // ensureGuestToken();
    setToken(null);
    setUserName(null);
  };

  useEffect(() => {
    const savedToken = localStorage.getItem("authToken");
    const savedName = localStorage.getItem("authUserName");
    if (savedToken) {
      setToken(savedToken);
      setUserName(savedName);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, userName, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
